import { type FC, useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop: FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname != null) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
